<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem; margin-bottom: 0!important;">
		<div class="py-2 border-bottom d-flex align-items-center">
			<el-button type="primary" size="mini" icon="el-icon-search">查询</el-button>
			<el-button type="primary" size="mini" @click="createTop" icon="el-icon-plus">添加</el-button>
		</div>
		<div>
			<el-table :data="tableData" style="width: 100%" highlight-current-row @current-change="handleCurrentChange" size="mini">
				<el-table-column width="80" align="center">
					<template slot="header" slot-scope="scope">编号</template>
					<template slot-scope="scope">{{scope.row.id}}</template>
				</el-table-column>
				<el-table-column width="330">
					<template slot="header" slot-scope="scope">名称</template>
					<template slot-scope="scope">{{scope.row.name}}</template>
				</el-table-column>
				<el-table-column width="300" align="center">
					<template slot="header" slot-scope="scope">价格类型</template>
					<template slot-scope="scope">
						<el-button type="primary" size="mini" plain v-if="scope.row.class == 1">销售价格表</el-button>
						<el-button type="success" size="mini" plain v-else>采购价格表</el-button>
					</template>
				</el-table-column>
				<el-table-column width="300" align="center">
					<template slot="header" slot-scope="scope">审核状态</template>
					<template slot-scope="scope">
						<el-button type="info" size="mini" plain v-if="scope.row.state == 0">待审核</el-button>
						<el-button type="primary" size="mini" plain v-else-if="scope.row.state == 1">已通过</el-button>
						<el-button type="danger" size="mini" plain v-else>已拒绝</el-button>
					</template>
				</el-table-column>
				<el-table-column align="center" fixed="right" width="220">
					<template slot="header" slot-scope="scope">操作</template>
					<template slot-scope="scope">
						<el-button type="primary" size="mini" @click="openModel(scope)">查看</el-button>
						<el-button type="primary" size="mini" @click="openModel(scope)">编辑</el-button>
						<el-button type="danger" size="mini">删除</el-button>
					</template>
				</el-table-column>
				
			</el-table>
		</div>
		
		<el-dialog title="表单详情" :visible.sync="createModel" top="5vh" style="" width="160vh">
			<!-- 表单内容 -->
			<div style="width: 100%;" class="d-flex">
				<div style="width: 50%;">
					<div style="font-size: 16px;border-bottom: 1px solid rgb(0, 0, 0,0.2);width: 90%;height: 30px;">价格表</div>
					<el-table :data="lists" style="width: 90%">
					    <el-table-column prop="id" label="编号" width="70" align="center"></el-table-column>
					    <el-table-column prop="name" label="产品名称" width="280"></el-table-column>
						<el-table-column prop="price" label="默认价格" width="100" align="center"></el-table-column>
						<el-table-column align="center">
							<template slot="header" slot-scope="scope">新的价格</template>
							<template slot-scope="scope">
								<el-input-number v-model="scope.row.num" :min="0" label="描述文字" size="small"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column align="center" width="80">
							<template slot="header" slot-scope="scope">
						        <el-button type="primary" size="mini" icon="el-icon-plus" @click="tjbg"></el-button>
							</template>
							<template slot-scope="scope">
						        <el-button type="danger" size="mini" icon="el-icon-delete" @click="del(scope)"></el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>				
				<div style="width: 50%;">
					<div style="font-size: 16px;border-bottom: 1px solid rgb(0, 0, 0,0.2);width: 90%;height: 30px;">基础信息</div>
					<div style="margin-top: 20px;">
						<el-form :rules="rules" ref="form" :model="form" label-width="80px">
							<el-form-item label="表名称" prop="name">
								<el-input v-model="form.name" placeholder="表名称" size="mini" style="width: 85%;"></el-input>
							</el-form-item>
							<el-form-item label="价格类型">
								<el-radio-group v-model="form.class">
									<el-radio-button :label="0" border>采购价格表</el-radio-button>
									<el-radio-button :label="1" border>销售价格表</el-radio-button>
								</el-radio-group>
							</el-form-item>
							<el-form-item label="供应商(需)" prop="user"><el-button type="success" size="mini">{{form.user}}</el-button></el-form-item>
							<el-form-item label="客户(需)" prop="user"><el-button type="success" size="mini">{{form.user}}</el-button></el-form-item>
						</el-form>
					</div>
					<div style="font-size: 16px;border-bottom: 1px solid rgb(0, 0, 0,0.2);width: 90%;height: 30px;margin-top: 30px;">批量改价：以参考价格为基数</div>
					<div style="margin-top: 20px;">
						<el-form label-width="80px">
							<el-form-item label="变动数值">
								<el-input-number v-model="num" @change="handleChange" :min="1" size="medium" style="width: 30%;"></el-input-number>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" size="small">增加数额</el-button>
								<el-button type="warning" size="small">增加数额</el-button>
								<el-button type="primary" size="small">增加数额</el-button>
								<el-button type="warning" size="small">增加数额</el-button>
								<el-button type="danger" size="small">全部清空</el-button>
							</el-form-item>
						</el-form>
						<div class="d-flex">
							
						</div>
					</div>
				</div>
			</div>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit(tableData)">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import buttonSearch from '@/components/common/button-search.vue'; // 引入 按钮、搜索、高级搜索组件
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	// 引入注册
	components: {
		buttonSearch
	},
	data() {
		return {
			num:994,
			rules: {

			},
			form: {
				id:10,
				create_time: '2022-08-19 14:40:20',
				name: '支',
				class:1,
				user:'你好啊',
				state:1,
			},
			createModel: false,
			currentRow: null,
			tableData: [
				{
					id:1,
					create_time: '2022-08-19 14:40:20',
					name: '顺丰',
					class:1,
					user:'你好啊',
					state:0
				},{
					id:2,
					create_time: '2022-08-19 14:40:20',
					name: '安泰',
					class:2,
					user:'你好啊',
					state:1
				},{
					id:3,
					create_time: '2022-08-19 14:40:20',
					name: '淘宝',
					class:1,
					user:'你好啊',
					state:2
				},{
					id:4,
					create_time: '2022-08-19 14:40:20',
					name: '耐克',
					class:1,
					user:'你好啊',
					state:1
				},
			],
			lists:[{
				id:112,
				name:'纺织布料',
				price:26,
				num:77
			},{
				id:112,
				name:'纺织布料',
				price:26,
				num:77
			}]
		};
	},

	methods: {
		handleChange(value){},
		createTop(){
			this.$prompt('请输入顶级分类名称', '提示', {
				confirmButtonText: '创建',
				cancelButtonText: '取消',
				inputValidator: function(val) {
					// 如果输入为空，则提示且不通过
					if (val === '' || val === null) {
						return '分类名称不能为空'
					}
					return true
				}
			}).then(({
				value
			})=>{
				value
				let e = {
					id:10,
					create_time: '2022-08-19 14:40:20',
					name: value,
					class:1,
					state:1
				}
				this.tableData.push(e)
			})
		},
		openModel(e = false) {
			console.log(e)
			this.tableData[e.row.id-1] = {
				id:e.row.id,
				create_time: '2022-08-19 14:40:20',
				name: e.row.name,
				class:e.row.class,
				state:1,
				user:'你好啊'
			};
			// 打开dialog
			this.createModel = true;
		},
		submit(e) {
			console.log(e)
			// this.tableData.push(e)
			this.createModel = false;
			// this.$refs.form.validate(res => {
			// 	if (res) {
			// 		console.log(res)
			// 		// 关闭模态框
			// 		this.createModel = false;
			// 	}
			// });
		},
		tjbg(){
			let e={
				id:112,
				name:'纺织布料',
				price:26,
				num:77
			}
			this.lists.push(e)
		},
		del(e){
			// let id = e.row.id
			// let nIndex = this.lists.indexOf(id);
			// console.log(9999,)
			// this.lists
			// .del()
		},
		handleCurrentChange(val) {
			this.currentRow = val;
		},
		
	}
};
</script>

<style></style>
